import { USER_PROFILE_PAGE_HEADER_FOOTER_ACTION } from '../../UserProfilePageHeaderFooter.constants'

export const USER_PROFILE_PAGE_PERFORM_ACTION_API_NAME = {
  [USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.approveRegistration]:
    'approve_registration',
  [USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.archive]: 'archive',
  [USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.restore]: 'restore',
  [USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.sendInvite]: 'send_invite',
}
